import { NavLink } from "react-router-dom";

interface BoxCardProps {
    url: string;
    image: string;
    title: string;
    description: string;
    isTranslate?: string;
    progress?: { current: number; total: number; label?: string };
    current: number;
    total: number;
    points: number;
    translate: (namespace: string, key: string, params?: any) => string;
}

export const BoxCard = ({
    url,
    image,
    title,
    description,
    isTranslate,
    progress,
    current,
    total,
    points,
    translate,
}: BoxCardProps) => {
    return (
        <NavLink
            to={url}
            className="bg-white shadow-lg rounded-lg px-2 py-2 border border-gray-200 flex flex-col items-center h-full min-h-[250px] transition-transform hover:scale-[1.02] hover:shadow-xl"
        >
            <img
                src={image}
                alt={title}
                className="h-24 w-full mb-3 object-contain"
            />
            <div className="text-center flex flex-col flex-grow justify-between w-full">
                <div>
                    <div className="sm:!text-sm md:!text-base font-semibold text-black">
                        {translate("INFINITY", title)}
                    </div>
                    <div className="sm:!text-sm md:!text-sm text-gray-600 mt-2 mb-3">
                        {isTranslate
                            ? translate("INFINITY", isTranslate, {
                                  amount: total.toString(),
                              })
                            : translate("INFINITY", description)}
                    </div>
                </div>

                {progress && (
                    <div className="w-full px-2 mt-auto mb-3">
                        <div className="text-xs text-gray-500 mb-0.5 text-center">
                            {current} / {total} {progress.label}
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                            <div
                                className="bg-gradient-to-l from-blue-500 to-indigo-900 h-full rounded-full transition-all duration-300"
                                style={{ width: `${(current / total) * 100}%` }}
                            />
                        </div>
                    </div>
                )}

                <div className="sm:!text-sm md:!text-sm font-medium text-black leading-8 mt-auto flex items-center justify-center text-center">
                    {points}
                    <img
                        src="/dist/image/Fav-Infinexia-512x512.webp"
                        className="w-4 h-4 ml-1 -mt-0.5"
                        alt="icon"
                    />
                </div>
            </div>
        </NavLink>
    );
};
